import { useCallback } from 'react';
import { useEvents } from '~/hooks';

export type FieldType = 'radio' | 'checkbox' | 'long_text' | 'short_text' | 'dropdown';

type FieldEventParams = {
  field_type: FieldType;
  element_name: string;
  element_value: string;
};

export const useFieldEvents = () => {
  const { events } = useEvents();

  const handleOnChange = useCallback(
    ({ element_name, field_type, element_value }: FieldEventParams) => {
      events.dispatchEventFormFieldInteracted({
        element_value,
        element_name,
        field_type,
      });
    },
    [events],
  );

  const handleOnBlur = useCallback(
    ({ element_name, field_type, element_value }: FieldEventParams) => {
      events.dispatchEventFormFieldInteracted({
        element_value,
        element_name,
        field_type,
      });
    },
    [events],
  );

  return { handleOnChange, handleOnBlur };
};
